export default "__VITE_ASSET__DRAqVGMQ__"